import axios from 'axios';
import { API_BASE_URL } from 'utils/constants';
import { redirectToPaymentPort, redirectToPaymentPortEng } from 'utils';
import { convertDateToTwoDigitsFormat } from 'utils/date';
import { redirectToAutoUpgrade } from 'utils/url';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,

  headers: {
    'Content-Type': 'application/json',
  },
});

export const handleFetchBills = async () => {
  const response = await axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: '/admin/invoices',
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

export const handleFetchPackages = async () => {
  const response = await axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: '/package/enabled',
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

export const handleValidateDiscountCode = async ({ code, packType }) => {
  const response = await axios({
    method: 'post',
    baseURL: API_BASE_URL,
    url: '/checkOffer',
    withCredentials: true,
    data: JSON.stringify({ code, packType }),
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

export const handleMakeInvoice = async (invoiceCredentials) => {
  const payloadData = {
    orderPack: invoiceCredentials.isPackageUpgrade ? true : false,
    officialEnabled: invoiceCredentials.isOfficialBillNeeded,
    paymentMethod: 'online',
    paymentGateway: 'بانک سامان',
  };
  if (invoiceCredentials.isPackageUpgrade) {
    payloadData.packType = invoiceCredentials.selectedPackageType;

    payloadData.offer = invoiceCredentials.discountCode
      ? invoiceCredentials.discountCode
      : 'offer';

    payloadData.myMonth =
      invoiceCredentials.selectedDuration === 'yearly'
        ? 12
        : invoiceCredentials.selectedDuration === 'triennial'
        ? 36
        : invoiceCredentials.selectedDuration === 'quarterly'
        ? 3
        : 1;

    payloadData.credit = invoiceCredentials.useCredit;
    payloadData.perMonth =
      invoiceCredentials.selectedPackage === 'professional' ? 49000 : 149000;
    payloadData.comFrom = 'comFrom';
  } else {
    payloadData.chargeCount = invoiceCredentials.selectedConversationCount;
  }
  const response = await axios({
    method: 'post',
    baseURL: API_BASE_URL,
    url: '/invoicing',
    withCredentials: true,
    data: JSON.stringify(payloadData),
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

export const handleSavePaymentInfo = async (payload) => {
  const res = await axiosInstance.post(
    '/container/saveOfficialDetails',
    JSON.stringify(payload)
  );

  return res.data;
};

export const handleCheckUserInfo = async (payload) => {
  const res = await axiosInstance.post(
    '/container/checkOfficialDetails',
    JSON.stringify(payload)
  );

  return res.data;
};

export const handleMakePayment = (invoiceId) => {
  redirectToPaymentPort(invoiceId);
};

export const handleAutoUpgrade = async ({ invoiceId, selectedBank }) => {
  const response = await axios({
    method: 'post',
    baseURL: API_BASE_URL,
    url: '/ipg/vandar/directdebit',
    withCredentials: true,
    data: JSON.stringify({
      bank_code: selectedBank,
      invoiceId,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

export const handleRedirectToAutoUpgrade = (url) => {
  redirectToAutoUpgrade(url);
};

export const handleFetchPaymentReport = async ({ token, paymentStatus }) => {
  const response = await axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: '/ipg/vandar/verify',
    withCredentials: true,
    params: {
      token,
      payment_status: paymentStatus,
    },
  });
  return response.data;
};

export const handleFetchPaymentInfo = async () => {
  const response = await axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: '/check-official',
    withCredentials: true,
  });
  return response.data;
};

export const makeInvoiceEng = async (invoiceCredentials) => {
  const res = await axiosInstance.post(
    '/ipg/paypal/invoice',
    invoiceCredentials
  );

  return res.data;
};

export const handleMakePaymentEng = async (invoiceId) => {
  redirectToPaymentPortEng(invoiceId);
};

export const handleFetchEngBills = async () => {
  const res = await axiosInstance.get('/ipg/paypal/invoices');

  return res.data;
};
